export default {
  path: '/ac2',
  component: () => import('@/views/ac2/index.vue'),
  children: [
    {
      path: 'request-log',
      name: 'Ac2RequestLog',
      component: () => import('@/views/ac2/pages/RequestLog.vue'),
      meta: {
        middleware: [
          'auth',
          'developer'
        ]
      }
    },
    {
      path: 'token-log',
      name: 'Ac2TokenLog',
      component: () => import('@/views/ac2/pages/TokenLog.vue'),
      meta: {
        middleware: [
          'auth',
          'developer'
        ]
      }
    },
    {
      path: 'queues',
      name: 'Ac2Queues',
      component: () => import('@/views/ac2/pages/Ac2Queues.vue'),
      meta: {
        middleware: [
          'auth',
          'developer'
        ]
      }
    },
    {
      path: 'webhook-log',
      name: 'Ac2WebhookLog',
      component: () => import('@/views/ac2/pages/WebhookLog.vue'),
      meta: {
        middleware: [
          'auth',
          'developer'
        ]
      }
    },
    {
      path: 'warehouse-config',
      name: 'Ac2WarehouseConfig',
      component: () => import('@/views/ac2/pages/WarehouseConfig.vue'),
      meta: {
        middleware: [
          'auth',
          'developer'
        ]
      }
    },
    {
      path: 'document-config',
      name: 'Ac2DocumentConfig',
      component: () => import('@/views/ac2/pages/DocumentConfig.vue'),
      meta: {
        middleware: [
          'auth',
          'developer'
        ]
      }
    }
  ]
}
